import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListInjectionProps from "../../../../components/@injection_props/ListInjectionProps";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function InjectionPropsPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListInjectionProps
                routeType={routeType}
            />
        </SettingFrame>
    )
}       